import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import SidebarMenuItem from './sidebarMenuItem'
import { signOutUser } from "../../api/auth";
import { connect } from 'react-redux'

class SideBarMenu extends Component {
	constructor() {
		super();
	}

	render() {
		return (

			<div className="sidebar__menu">
				<ul>
					{
						this.props.menuItems.map((item, key) => (
							<SidebarMenuItem key={key} item={item}  />
						))
					}
				</ul>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {};
};

export default connect(mapStateToProps, {
	signOutUser
})(SideBarMenu);


// WEBPACK FOOTER //
// ./src/application/templates/sidebarMenu.js